/**
 * @generated SignedSource<<7dec5d911d8d729060e7c86a5f17d210>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type labels_issueFieldLabelsReadviewFull_LabelsReadView$data = {
  readonly fieldId: string;
  readonly selectedLabelsConnection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly color: {
          readonly colorKey: string | null | undefined;
        } | null | undefined;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly totalCount: number | null | undefined;
  };
  readonly " $fragmentType": "labels_issueFieldLabelsReadviewFull_LabelsReadView";
};
export type labels_issueFieldLabelsReadviewFull_LabelsReadView$key = {
  readonly " $data"?: labels_issueFieldLabelsReadviewFull_LabelsReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"labels_issueFieldLabelsReadviewFull_LabelsReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "labels_issueFieldLabelsReadviewFull_LabelsReadView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "RequiredField",
      "field": {
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 1000
          }
        ],
        "concreteType": "JiraLabelConnection",
        "kind": "LinkedField",
        "name": "selectedLabelsConnection",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "totalCount"
          },
          {
            "concreteType": "JiraLabelEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraLabel",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "colorKey"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ],
        "storageKey": "selectedLabelsConnection(first:1000)"
      },
      "action": "THROW",
      "path": "selectedLabelsConnection"
    }
  ],
  "type": "JiraLabelsField"
};

(node as any).hash = "3f7bd1f7c0b3da8b1c1b35313d9735b4";

export default node;
